import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=20c78ee7&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=20c78ee7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c78ee7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20c78ee7')) {
      api.createRecord('20c78ee7', component.options)
    } else {
      api.reload('20c78ee7', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=20c78ee7&scoped=true&", function () {
      api.rerender('20c78ee7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2GZ57B9oWzZAL/JS/comp/GuestBox.vue"
export default component.exports